import { useEffect, useState, useCallback } from 'react';
import { apiClient } from '../index';

interface CampaignTagsResponse {
  tags: string[];
}

export const useCampaignTags = () => {
  const [tags, setTags] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTags = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await apiClient.get<CampaignTagsResponse>('/api/campaign-tags');
      setTags(Array.isArray(result?.tags) ? result.tags : []);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch campaign tags');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTags();
  }, [fetchTags]);

  return { tags, loading, error, refetch: fetchTags };
};
